var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasBars
    ? _c("div", { staticClass: "transcript-criteria-bars d-flex" }, [
        _c(
          "div",
          { staticClass: "transcript-criteria-bars__names" },
          _vm._l(_vm.criteria, function(item) {
            return _c(
              "div",
              {
                key: item.id,
                staticClass:
                  "transcript-criteria-bars__name d-flex align-center",
                style: { height: _vm.rowHeight + "px" }
              },
              [
                _c(
                  "span",
                  { staticClass: "az-text-primary az-size-14 text-truncate" },
                  [_vm._v(" " + _vm._s(item.name) + " ")]
                )
              ]
            )
          }),
          0
        ),
        _c(
          "div",
          { staticClass: "flex-grow-1" },
          [
            _c("bar-horizontal-chart", {
              attrs: {
                "chart-data": _vm.chartConfig.chartData,
                options: _vm.chartConfig.chartOptions,
                plugins: _vm.chartConfig.chartPlugins,
                height: _vm.chartHeight
              }
            })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }